import { settingsRouteToEmberSettingsRoute } from '@views/settings/constants/settingsRouteToEmberSettingsRoute'
import { umbrellaRouteToEmberRoute } from '@views/umbrella/constants/umbrellaRouteToEmberRoute'

import { isEmberRoute } from '../../../utils/routing/isEmberRoute'
import { SearchResultItem } from '../types/searchResultItem'

export const getGlobalSearchEventToValue = (item: SearchResultItem): string => {
  const { id, category, routeTo, to } = item

  if (category === 'menu' && to) {
    return id
  }

  if (routeTo && isEmberRoute(routeTo)) {
    const isSettingsEmberRoute = !!routeTo && Object.values(settingsRouteToEmberSettingsRoute).includes(routeTo)
    const isUmbrellaEmberRoute = !!routeTo && Object.values(umbrellaRouteToEmberRoute).includes(routeTo)

    if (isUmbrellaEmberRoute || isSettingsEmberRoute) {
      return routeTo
    }
  }

  return category
}
